import packageJson from '../../package.json';

const CDN_URL = 'https://uikit.developers.rio.cloud';
const staticAssetsBaseUrl = packageJson.version.includes('-')
    ? `${CDN_URL}/${packageJson.version}`
    : `${CDN_URL}/static`;

export const staticAssetsUrl = import.meta.env.DEV ? '/static' : staticAssetsBaseUrl;
